// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-temp-wrapper {
  padding: 0 16px 0px 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.checklist-temp-wrapper .show-more-btn {
  padding: 0;
  color: var(--sdk-global-theme-color);
  text-align: start;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
}
.checklist-temp-wrapper .show-more-btn.hide-show-details {
  width: 100%;
  font-weight: 400;
  padding-left: 14px;
  margin-bottom: 14px;
}

.checklist-card {
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--sdk-global-white-bg);
  text-align: start;
  min-height: 98px;
  transition: 0.2s all ease;
  padding: 0;
}
.checklist-card:not(.no-bg-hover-card):hover {
  background: var(--sdk-gloabl-bg-secondary);
}
.checklist-card:hover .manage-card-block .progress-circle-block .checklist-progress::before {
  background-image: conic-gradient(transparent var(--percentage), var(--sdk-global-white-bg) var(--percentage));
}
.checklist-card:hover .manage-card-block .progress-circle-block .checklist-progress .checklist-percentage {
  background: var(--sdk-gloabl-bg-secondary);
}
.checklist-card .manage-card-block {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px;
  transition: 0.2s all ease;
}
.checklist-card .manage-card-block:hover {
  background: var(--sdk-gloabl-bg-secondary);
}
.checklist-card .manage-card-block .left-block-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
}
.checklist-card .manage-card-block .left-block-details h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}
.checklist-card .manage-card-block .left-block-details .status-data-block {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.checklist-card .manage-card-block .left-block-details .status-data-block .status-data {
  padding-right: 10px;
  border-right: 1px solid var(--sdk-gloabl-border-color);
  max-width: 100%;
  overflow: hidden;
  min-width: 70px;
}
.checklist-card .manage-card-block .left-block-details .status-data-block .status-data:last-child {
  border: 0;
  padding: 0;
}
.checklist-card .manage-card-block .left-block-details .status-data-block .status-data h2 {
  overflow: hidden;
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.checklist-card .manage-card-block .left-block-details .status-data-block .status-data p {
  overflow: hidden;
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.checklist-card .manage-card-block .progress-circle-block {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 100%;
}
.checklist-card .manage-card-block .progress-circle-block .checklist-progress {
  --percentage: calc(0 * 1%);
  background-image: conic-gradient(var(--sdk-global-theme-color) 100%, var(--sdk-global-theme-color) 100%, var(--sdk-global-theme-color) 100%);
  border-radius: 50%;
  height: 64px;
  position: relative;
  width: 64px;
  flex-shrink: 0;
}
.checklist-card .manage-card-block .progress-circle-block .checklist-progress::before {
  background-image: conic-gradient(transparent var(--percentage), var(--sdk-gloabl-bg-secondary) var(--percentage));
  border-radius: 50%;
  content: "";
  height: 64px;
  left: 0;
  position: absolute;
  width: 64px;
}
.checklist-card .manage-card-block .progress-circle-block .checklist-progress .checklist-percentage {
  --inner-size: calc(64px - 3 * 5px);
  margin: 0;
  padding: 0;
  place-items: center;
  text-align: center;
  border-radius: 50%;
  font-size: calc(var(--inner-size) / 3);
  height: var(--inner-size);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--inner-size);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 12px;
  line-height: 19px;
  background: var(--sdk-global-white-bg);
}
.checklist-card .manage-card-block .progress-circle-block .checklist-progress .checklist-percentage::after {
  -webkit-text-fill-color: transparent;
  background-clip: text;
  background-image: linear-gradient(to right, var(--text-colors));
  background-position: var(--percentage);
  background-size: 100000%;
  counter-reset: value 0;
}
.checklist-card .more-details-status-type {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.checklist-card .more-details-status-type .details-card-status {
  display: flex;
  padding: 10px 14px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-bottom: 1px solid var(--sdk-gloabl-border-color);
  transition: 0.2s all ease;
}
.checklist-card .more-details-status-type .details-card-status:last-child {
  border: 0;
}
.checklist-card .more-details-status-type .details-card-status:hover {
  background: var(--sdk-gloabl-bg-secondary);
}
.checklist-card .more-details-status-type .details-card-status .details-card-status-header {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}
.checklist-card .more-details-status-type .details-card-status .details-card-status-header figure {
  flex-shrink: 0;
}
.checklist-card .more-details-status-type .details-card-status .details-card-status-header h2 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  width: 100%;
}
.checklist-card .more-details-status-type .details-card-status .status-heading {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
.checklist-card .more-details-status-type .details-card-status .status-heading h3 {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  min-width: 75px;
}
.checklist-card .more-details-status-type .details-card-status .status-heading .status-info {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--sdk-gloabl-text-color);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}
.checklist-card .more-details-status-type .details-card-status .status-heading .status-info figure {
  line-height: 0;
}
.checklist-card .more-details-status-type .details-card-status .status-heading .status-info span {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}
.checklist-card .more-details-status-type .details-card-status .status-heading p {
  color: var(--sdk-gloabl-text-color);
  opacity: 0.6;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  width: 100%;
}
.checklist-card .more-details-status-type.hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/checkList/checkList.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACJ;AACI;EACI,UAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AACR;AAAQ;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAEZ;;AAGA;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;AAAJ;AAEQ;EACI,0CAAA;AAAZ;AAOoB;EACI,6GAAA;AALxB;AAQoB;EACI,0CAAA;AANxB;AAaI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AAXR;AAYQ;EACI,0CAAA;AAVZ;AAYQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAVZ;AAYY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAVhB;AAaY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAXhB;AAagB;EACI,mBAAA;EACA,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAXpB;AAaoB;EACI,SAAA;EACA,UAAA;AAXxB;AAcoB;EACI,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAZxB;AAeoB;EACI,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAbxB;AAmBQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EAEA,mBAAA;AAlBZ;AAoBY;EACI,0BAAA;EACA,4IAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAlBhB;AAoBgB;EACI,iHAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AAlBpB;AAqBgB;EACI,kCAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;AAnBpB;AAqBoB;EACI,oCAAA;EACA,qBAAA;EACA,+DAAA;EACA,sCAAA;EACA,wBAAA;EACA,sBAAA;AAnBxB;AA0BI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;AAxBR;AA0BQ;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,uDAAA;EACA,yBAAA;AAxBZ;AAyBY;EACI,SAAA;AAvBhB;AAyBY;EACI,0CAAA;AAvBhB;AAyBY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAvBhB;AAyBgB;EACI,cAAA;AAvBpB;AA0BgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAxBpB;AA4BY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AA1BhB;AA4BgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA1BpB;AA6BgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA3BpB;AA6BoB;EACI,cAAA;AA3BxB;AA8BoB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA5BxB;AAgCgB;EACI,mCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA9BpB;AAmCQ;EACI,aAAA;AAjCZ","sourcesContent":[".checklist-temp-wrapper {\n    padding: 0 16px 0px 16px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .show-more-btn {\n        padding: 0;\n        color: var(--sdk-global-theme-color);\n        text-align: start;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        border: 0;\n        background: transparent;\n        cursor: pointer;\n        display: inline-flex;\n        &.hide-show-details {\n            width: 100%;\n            font-weight: 400;\n            padding-left: 14px;\n            margin-bottom: 14px;\n        }\n    }\n}\n\n.checklist-card {\n    flex-direction: column;\n    width: 100%;\n    border-radius: 4px;\n    border: 1px solid var(--sdk-gloabl-border-color);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: var(--sdk-global-white-bg);\n    text-align: start;\n    min-height: 98px;\n    transition: 0.2s all ease;\n    padding: 0;\n    &:not(.no-bg-hover-card){\n        &:hover{\n            background: var(--sdk-gloabl-bg-secondary);\n        }\n    }\n    &:hover {\n        .manage-card-block {\n            .progress-circle-block {\n                .checklist-progress {\n                    &::before {\n                        background-image: conic-gradient(transparent var(--percentage), var(--sdk-global-white-bg) var(--percentage));\n                    }\n\n                    .checklist-percentage {\n                        background: var(--sdk-gloabl-bg-secondary);\n                    }\n                }\n            }\n        }\n    }\n\n    .manage-card-block {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 14px;\n        transition: 0.2s all ease;\n        &:hover{\n            background: var(--sdk-gloabl-bg-secondary);\n        }\n        .left-block-details {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n            overflow: hidden;\n\n            h1 {\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 600;\n                line-height: normal;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                width: 100%;\n            }\n\n            .status-data-block {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                width: 100%;\n\n                .status-data {\n                    padding-right: 10px;\n                    border-right: 1px solid var(--sdk-gloabl-border-color);\n                    max-width: 100%;\n                    overflow: hidden;\n                    min-width: 70px;\n\n                    &:last-child {\n                        border: 0;\n                        padding: 0;\n                    }\n\n                    h2 {\n                        overflow: hidden;\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 12px;\n                        font-weight: 400;\n                        line-height: normal;\n                        margin: 0;\n                        overflow: hidden;\n                        white-space: nowrap;\n                        text-overflow: ellipsis;\n                    }\n\n                    p {\n                        overflow: hidden;\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 18px;\n                        margin: 0;\n                        overflow: hidden;\n                        white-space: nowrap;\n                        text-overflow: ellipsis;\n                    }\n                }\n            }\n        }\n\n        .progress-circle-block {\n            flex-shrink: 0;\n            width: 64px;\n            height: 64px;\n            // border: 2px solid var(--sdk-gloabl-border-color);\n            border-radius: 100%;\n\n            .checklist-progress {\n                --percentage: calc(0 * 1%);\n                background-image: conic-gradient(var(--sdk-global-theme-color) 100%, var(--sdk-global-theme-color) 100%, var(--sdk-global-theme-color) 100%);\n                border-radius: 50%;\n                height: 64px;\n                position: relative;\n                width: 64px;\n                flex-shrink: 0;\n\n                &::before {\n                    background-image: conic-gradient(transparent var(--percentage), var(--sdk-gloabl-bg-secondary) var(--percentage));\n                    border-radius: 50%;\n                    content: \"\";\n                    height: 64px;\n                    left: 0;\n                    position: absolute;\n                    width: 64px;\n                }\n\n                .checklist-percentage {\n                    --inner-size: calc(64px - 3 * 5px);\n                    margin: 0;\n                    padding: 0;\n                    place-items: center;\n                    text-align: center;\n                    border-radius: 50%;\n                    font-size: calc(var(--inner-size) / 3);\n                    height: var(--inner-size);\n                    left: 50%;\n                    position: absolute;\n                    top: 50%;\n                    transform: translate(-50%, -50%);\n                    width: var(--inner-size);\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    font-weight: 900;\n                    font-size: 12px;\n                    line-height: 19px;\n                    background: var(--sdk-global-white-bg);\n\n                    &::after {\n                        -webkit-text-fill-color: transparent;\n                        background-clip: text;\n                        background-image: linear-gradient(to right, var(--text-colors));\n                        background-position: var(--percentage);\n                        background-size: 100000%;\n                        counter-reset: value calc(0);\n                    }\n                }\n            }\n        }\n    }\n\n    .more-details-status-type {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n\n        .details-card-status {\n            display: flex;\n            padding: 10px 14px;\n            flex-direction: column;\n            justify-content: center;\n            align-items: flex-start;\n            gap: 4px;\n            align-self: stretch;\n            border-bottom: 1px solid var(--sdk-gloabl-border-color);\n            transition: 0.2s all ease;\n            &:last-child{\n                border: 0;\n            }\n            &:hover{\n                background: var(--sdk-gloabl-bg-secondary);\n            }\n            .details-card-status-header {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n                width: 100%;\n\n                figure {\n                    flex-shrink: 0;\n                }\n\n                h2 {\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 600;\n                    line-height: normal;\n                    width: 100%;\n                }\n            }\n\n            .status-heading {\n                display: flex;\n                align-items: center;\n                width: 100%;\n                gap: 8px;\n\n                h3 {\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    min-width: 75px;\n                }\n\n                .status-info {\n                    display: flex;\n                    align-items: center;\n                    gap: 4px;\n                    color: var(--sdk-gloabl-text-color);\n                    text-align: center;\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n\n                    figure {\n                        line-height: 0;\n                    }\n\n                    span {\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 12px;\n                        font-weight: 400;\n                        line-height: normal;\n                    }\n                }\n\n                p {\n                    color: var(--sdk-gloabl-text-color);\n                    opacity: 0.6;\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: normal;\n                    margin: 0;\n                    width: 100%;\n                }\n            }\n        }\n\n        &.hide {\n            display: none;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
